import {ApiEndPoint} from "../../network/api_end_point";
import {apiCaller, getToken} from "../../network/network_helper";

const apiEndPoint = new ApiEndPoint();

export const orderDetailsApiCall=async(taskId,pageSize,page)=>{
    try{
        const token=getToken();
        return await apiCaller(apiEndPoint.hawkBaseUrl + apiEndPoint.orderDetailsUrl + taskId, {
            method: 'GET',
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            params:{
                page_size:pageSize,
                page: page,
                source: apiEndPoint.source
            }
        });

    }catch(e){
        throw e;
    }
}